module.exports = __webpack_public_path__ + "assets/bdc584e8def0439257a380882a56cfae.png";